// =============================================================
// Lightweight toast — single DOM element appended on demand,
// fades out after 2.5s. Mirrors showToastNotification() in
// the original index.html.
// =============================================================

export function showToast(text: string): void {
  const toast = document.createElement('div')
  toast.style.position = 'fixed'
  toast.style.top = '16px'
  toast.style.left = '50%'
  toast.style.transform = 'translateX(-50%)'
  toast.style.background = 'var(--slate-dark)'
  toast.style.color = 'var(--white)'
  toast.style.padding = '8px 16px'
  toast.style.borderRadius = 'var(--radius-pill)'
  toast.style.fontSize = '12px'
  toast.style.fontWeight = '600'
  toast.style.boxShadow = 'var(--shadow-lg)'
  toast.style.zIndex = '99999'
  toast.style.opacity = '0.95'
  toast.style.pointerEvents = 'none'
  toast.textContent = text
  document.body.appendChild(toast)
  setTimeout(() => {
    toast.style.transition = 'opacity 0.5s'
    toast.style.opacity = '0'
    setTimeout(() => toast.remove(), 500)
  }, 2500)
}